import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import LoanStore from '@/loan/store';
import { Route } from 'vue-router';
import { LoanAPIService } from '@/loan/services/api';

const loanStore = getModule(LoanStore, store);

export const loanTransactionsResolver = async (to: Route): Promise<void> => {
	const { loanId } = to.params;
	const transactions = await LoanAPIService.getTransactionsWithDetails(loanId);

	loanStore.setTransactions(transactions);
};
